import useSWR, { mutate } from 'swr';
import { useMemo } from 'react';
// utils
import axios, { fetcher, endpoints } from 'src/utils/axios';

// ----------------------------------------------------------------------

export function useGetRevZone(id) {
  const URL = `${endpoints.revzone.list}/${id}/assigned`;

  const { data, isLoading, error, isValidating } = useSWR(URL, fetcher, {
    shouldRetryOnError: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });
  const response = data?.data;
  const memoizedValue = useMemo(
    () => ({
      revzone: response || [],
      revzoneLoading: isLoading,
      revzoneError: error,
      revzoneValidating: isValidating,
      revzoneEmpty: !isLoading && !response?.revzone?.length,
    }),
    [response, error, isLoading, isValidating]
  );

  return memoizedValue;
}

export function useGetLeads(id) {
  const URL = `${endpoints.leads.list}${id}`;

  const { data, isLoading, error, isValidating } = useSWR(URL, fetcher, {
    shouldRetryOnError: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });
  const response = data?.data;
  const memoizedValue = useMemo(
    () => ({
      leads: response?.leads || [],
      leadsLoading: isLoading,
      leadsError: error,
      leadsValidating: isValidating,
      leadsEmpty: !isLoading && !response?.leads?.length,
    }),
    [response?.leads, error, isLoading, isValidating]
  );
  return memoizedValue;
}

export async function CreateLead(apiData, id, managerId,selectedBuilding, leadID, status, isEdit) {
  const URL = `${endpoints.revzone.list}/${id}/assigned`;
  const URL2 = `${endpoints.leads.list}${managerId}`;
  const URL3 = `${endpoints.crm.list}${managerId}`;

  try {
    const { data } =selectedBuilding?.leadStatus=='go_back' || status === 'go_back' ?
      await axios.put( `/canvasser/lead/v1/crm/convert/go-back/${selectedBuilding?.leadsId || leadID}`, apiData) :
        isEdit ? await axios.put(`${endpoints.leads.update}/${selectedBuilding?.leadsId || leadID}`, apiData) :
          await axios.post(endpoints.leads.create, apiData)
    if (data.code === 200) {
      await mutate(URL2);
      await mutate(URL3);
      console.log('Mutated URL2');

      await mutate(URL, undefined, { revalidate: true });
      console.log('Mutated revzone URL');
    }
    return data;
  } catch (error) {
    console.error('Error creating user:', error);
    throw error;
  }
}

export async function updateLead(apiData, id, managerId) {
  const URL = `${endpoints.leads.list}${managerId}`;
  try {
    const { data } = await axios.put(`${endpoints.leads.update}/${id}`, apiData);
    if (data.code === 200) {
      await mutate(URL);
    }
    return data;
  } catch (error) {
    console.error('Error creating user:', error);
    throw error;
  }
}

export async function deleteLead(userId, managerId) {
  const URL = `${endpoints.leads.list}${managerId}`;

  try {
    const { data } = await axios.delete(`${endpoints.leads.delete}/${userId}`);
    if (data.code === 200) {
      mutate(URL);
    }

    return data;
  } catch (error) {
    console.error('Error deleting user:', error);
    throw error;
  }
}
